import styled from "styled-components";
import { Edit, Timer, UserImg } from "../../../../../public/assets";
import { useState } from "react";
import EditUserModal from "./EditUserModal";
import DisableUsersModal from "./DisableUsersModal";
import OutsideClickHandler from "../../../../components/OutsideClickHandler/OutsideClickHandler";

const AccountDropdownMain = styled.div`
  width: 100%;
  background: white;
  box-shadow: 0px 4px 19px 0px #aaaaaa21;
  border-radius: 5px;
  padding: 10px 0;
  border: 1px solid #e8eaed;
`;

const AccountDropdownContent = styled.div`
  display: flex;
  align-items: center;
  width: 85%;
  margin: 0 auto;
  padding: 10px 0;
  cursor: pointer;
`;

const ActionDropdownImg = styled.img`
  margin-right: 15px;
`;
interface ActionDropdownProps {
  // setShowAction: (state: boolean) => void;
  // showAction: boolean;
}
const ActionDropdown: React.FC<ActionDropdownProps> = (
  {
    // setShowAction,
    // showAction,
  }
) => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDisableModal, setShowDisableModal] = useState(false);

  const handleEdit = () => {
    setShowEditModal(true);
  };

  const handleDisable = () => {
    setShowDisableModal(true);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
  };

  const handleCloseDisableModal = () => {
    setShowDisableModal(false);
  };

  const handleEditSubmit = () => {};

  const handleDisableSubmit = () => {};

  return (
    // <OutsideClickHandler
    //   showDiv={setShowAction}
    //   show={showAction}
    //   className="outsideClick"
    // >
    <AccountDropdownMain>
      <AccountDropdownContent>
        <ActionDropdownImg
          onClick={handleEdit}
          src="/assets/svg/edit-2.svg"
          alt="Edit icon"
        />
        <span>Edit User Details</span>
      </AccountDropdownContent>
      <AccountDropdownContent>
        <ActionDropdownImg src="/assets/svg/user.svg" alt="user profile" />
        <span>View User Activities</span>
      </AccountDropdownContent>
      <AccountDropdownContent onClick={handleDisable}>
        <ActionDropdownImg src="/assets/svg/timer.svg" alt="timer icon" />
        <span>Disable User</span>
      </AccountDropdownContent>
      {showEditModal && (
        <EditUserModal
          onClose={handleCloseEditModal}
          onSubmit={handleEditSubmit}
        />
      )}
      {showDisableModal && (
        <DisableUsersModal
          onClose={handleCloseDisableModal}
          onSubmit={handleDisableSubmit}
        />
      )}
    </AccountDropdownMain>

    // </OutsideClickHandler>
  );
};

export default ActionDropdown;
